// removed by extract-text-webpack-plugin
module.exports = {"preloader":"_3QfXSZWpNyyDcBOyZwJ1Lz"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/PropertyDetailsPage/PropertyDetailsPage.scss
// module id = 1831
// module chunks = 0